import { render, staticRenderFns } from "./google-map.vue?vue&type=template&id=228c883a&scoped=true"
import script from "./google-map.vue?vue&type=script&lang=js"
export * from "./google-map.vue?vue&type=script&lang=js"
import style0 from "./google-map.vue?vue&type=style&index=0&id=228c883a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c883a",
  null
  
)

export default component.exports